import { MY_CONTENT_STORE } from '@/app/private/my-content/store/my-content.store';
import { _APP_STORE } from '@/core/values/app.values';
import { _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'ed-portal-tasks',
  components: {
    EdHomeworksContainer: () => import(/* EdHomeworksContainer */'@/homework/component/ed-homeworks-container/ed-homeworks-container.vue'),
    EdCourses: () => import(/* EdCourses */'@/content/pages/student-portal/components/ed-courses/ed-courses.vue')
  }
})
class EdPortalTasksComponent extends Vue {

  get isStudent() {
    return this.$store.getters['AuthStore/isStudent']
  }

  refreshCourseTasks({ courseId, sectionId }) {
    this.$store.commit(
      _HOMEWORKS_STORE.MUTATIONS.REMOVE_STUDENT_HOMEWORK,
      { courseId, sectionId }
    );
  }

  created() {
    this.$edEventBus.$on(SCREEN_MIRRORING_EVENTS.ON_REFRESH_COURSE, this.refreshCourseTasks);
  }

  beforeDestroy() {
    this.$store.commit(_HOMEWORKS_STORE.MUTATIONS.INIT);
    this.$store.commit(MY_CONTENT_STORE.MUTATIONS.SET_COURSES_ALREADY_LOADED, false);
    if(!this.isStudent) {
      this.$store.dispatch(_APP_STORE.ACTIONS.CLEAN_TEACHER_POSITION);
    }
  }
  
}

export default Vue.component('ed-portal-tasks', EdPortalTasksComponent);